/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import AllReports from "./AllReports";
import PatientEngagementTable from "./PatientEngagementTable";
import { featureCheck } from "../../utils/feature";

const MissedAndDueList = () => {
  const [selectedTab, setSelectedTab] = useState("");
  const [checkedItems, setCheckedItems] = useState([]);
  const shouldShowPatientEngagementTab = featureCheck("patientEngagementFeature.enable");
  let location = useLocation();

  useEffect(() => {
    const tab = location?.pathname.split("/").filter(Boolean).pop();
    if (typeof tab === "undefined") {
      setSelectedTab("missed");
    } else if (tab == "due") {
      setSelectedTab("dues");
    } else {
      setSelectedTab(tab);
    }
  }, [location]);

  useEffect(() => {
    return () => localStorage.removeItem("patients-offset");
  }, []);

  const classNameTab = (pos) => {
    if (pos === selectedTab) return "tabActive";
    else return "";
  };

  return (
    <div id="index" className="containerFlex maxHd">
      <div className="contentArea">
        <nav className="tabs" id="report-navigation">
          <NavLink
            to="/reports3/missed"
            className={classNameTab("missed")}
            onClick={() => {
              localStorage.setItem("patients-offset", "missed");
              setSelectedTab("missed");
            }}
          >
            <span className="tab-text">Missed Reports</span>
          </NavLink>
          <NavLink
            to="/reports3/due"
            className={classNameTab("dues")}
            onClick={() => {
              localStorage.setItem("patients-offset", "dues");
              setSelectedTab("dues");
            }}
          >
            <span className="tab-text">Due Reports</span>
          </NavLink>
          {shouldShowPatientEngagementTab ? (
            <NavLink
              to="/reports3/patientengagement"
              className={classNameTab("patientengagement")}
              onClick={() => {
                localStorage.setItem("patients-offset", "patientengagement");
                setSelectedTab("patientengagement");
              }}
            >
              <span className="tab-text">Patient Engagement</span>
            </NavLink>
          ) : null}
        </nav>
        <div className="tabContent">
          {selectedTab === "patientengagement" ? (
            <PatientEngagementTable />
          ) : (
            <AllReports
              activeTab={selectedTab}
              setCheckedItems={setCheckedItems}
              checkedItems={checkedItems}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MissedAndDueList;
